import { Requester } from './Requester';
import { IUser } from '../types';

export const GetContactUser = async ({ contactId }: { contactId: string }): Promise<IUser | null> => {
    try {
        const response = await Requester<{ user: IUser | boolean } | null>({
            path: `contacts/${contactId}/user`,
            method: 'GET'
        });

        return response && 'user' in response && response.user !== false ? (response.user as IUser) : null;
    } catch (e) {
        console.error('Get contact user request failed');
        return Promise.reject(e);
    }
};
